import React, { useState, useEffect } from "react";
import { Modal, } from "react-bootstrap";

import "../navbar2/activity-form/activity-form.css";
import "./copy-activity-modal.css"
import {
  getAllTrails,
} from "../../services";

import { CopyActivityForm } from "./CopyActivityForm";

const CopyActivityModal = ({ payload, showModal, closeModalHandler, activityDetails, }) => {
  const [trails, setTrails] = useState(null);

  // fetch user activities on page load. TODO: Maybe we can do this better using the outlet since this has already been loaded in navbar
  const updateTrails = () => {
    getAllTrails().then((result) => {
      setTrails(result);
    });
  };

  useEffect(() => {
    updateTrails();
  }, []);

  return (
    <Modal
      show={showModal}
      onHide={closeModalHandler}
      className="copyActivityModal"
      >
        <CopyActivityForm 
          activityDetails={activityDetails}
          trails={trails}
          closeModal={closeModalHandler}
          />
    </Modal>
  );
};

export default CopyActivityModal;
